var map = {
	"./vcambra/default-logo.png": 29573,
	"./vcambra/favicon.png": 9818,
	"./vcambra/footer-logo.png": 65865,
	"./vcambra/logo-1.svg": 50524,
	"./vcambra/logo-2.svg": 29551,
	"./vcambra/logo-3.svg": 85822,
	"./vcambra/logo-header-mobile.svg": 46019,
	"./vcambra/logo-header-tablet.svg": 35061,
	"./vcambra/logo-header.svg": 41664,
	"./vcambra/logo-mobile.svg": 63429,
	"./vcambra/logo.svg": 35750,
	"./vcambra/maskable-icon.png": 49144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68869;